<template>
  <div class="row">
    <div class="col-lg-12">
      <b-card header="<i class='fa fa-align-justify'></i> Browse Upload Laporan">
        <div class="row">
          <div class="col-12">
          </div>
        </div>
        <!--form action="#/Brows/Listbrows" method="GET"-->

        <form action="#/pengajuan/browseupload">

          <div role="group" class="form-group row">
            <div class="col-4">
              <div role="group" class="input-group">
                <input placeholder="Pencarian" class="form-control" type="text" v-model="q">
                <div class="input-group-btn">
                  <button type="submit" @click="getBrows()" class="btn btn-outline-primary"><i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-4">

            </div>
            <div class="col-sm-4">
              <select class="form-control form-control-sm" v-model="b" @change="getBrows()">
                <option value="">Semua Laporan</option>
                <option value=1>Laporan TPS</option>
                <option value=2>Laporan Kawasan Pabean</option>
                <option value=3>Laporan TPE</option>
                <option value=4>Rekonsiliasi Outward Manifes - Barkir</option>
              </select>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-hover table-sm">
              <thead>
                <tr>
                  <th class="d-none d-sm-block" v-align="middle" @click="setC('NM_PERUSAHAAN')"><a
                      href="#/pengajuan/browseupload">Nama Perusahaan</a></th>
                  <th><a href="#/pengajuan/browseupload" @click="setC('perijinan.tl_hdr.wk_kirim')">Waktu Kirim</a></th>
                  <th style="align:center"><a href="#/pengajuan/browseupload"
                      @click="setC('perijinan.tl_hdr.tgl_awal')">Tanggal Awal</a></th>
                  <th class="d-none d-sm-block"><a href="#/pengajuan/browseupload"
                      @click="setC('perijinan.tl_hdr.tgl_akhir')">Tanggal Akhir</a></th>
                  <th><a href="#/pengajuan/browseupload" @click="setC('perijinan.tl_hdr.jns_laporan')">Jenis Laporan</a>
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="brow in brows.data">
                  <td class="d-none d-sm-block">{{ brow.NM_PERUSAHAAN }}</td>
                  <td>{{ brow.wk_rekam }} {{ brow.wk_kirim }}</td>
                  <td>{{ brow.tgl_awal }}</td>
                  <td>{{ brow.tgl_akhir }}</td>
                  <td>{{ brow.jenis }}</td>
                  <td>
                    <!-- <router-link class="btn btn-warning" :to="'/laporan/pengawasan/' + brow.id_permohonan" title="Rekam Laporan"><i class="fa fa-edit"></i></router-link> -->
                    <a title="Download" @click=""
                      :href="$http.options.root + '/unduh/' + brow.id_tl_hdr + '/' + brow.nm_file"
                      class="btn btn-success"><i class="fa fa-download"></i></a>
                    <button @click="getData(brow.id_tl_hdr, brow.jns_laporan)" class="btn btn-primary"><i
                        class="fa fa-eye"></i></button>
                    <!-- <a title="Download" @click="" :href="'http://localhost/backper/public/api/unduh/' + brow.id_tl_hdr + '/' + brow.nm_file"class="btn btn-success" ><i class="fa fa-download"></i></a> -->
                    <!-- <a title="Print Ijin" v-if="brow.no_setuju !== null && brow.nm_file === null" :href="'http://103.233.145.212/backper/public/api/pdfBc/' + brow.id_permohonan" target="_blank" class="btn btn-success" ><i class="fa fa-print"></i></a>
                    <a title="Print Ijin" v-if="brow.no_setuju !== null && brow.nm_file !== null" :href="'http://103.233.145.212/backper/public' + brow.url_file + '/' + brow.nm_file" target="_blank" class="btn btn-success"><i class="fa fa-print"></i></a -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-8">
          <div class="pagination">
            <button class="btn btn-primary" @click="getBrows(brows.first_page_url)" :disabled="!brows.prev_page_url">
              &laquo;
            </button>
            <button class="btn btn-primary" @click="getBrows(brows.prev_page_url)" :disabled="!brows.prev_page_url">
              &lsaquo;
            </button>
            <!--button class="btn btn-primary">{{ brows.current_page }} / {{ brows.last_page }} </button-->
            <div><input :placeholder="brows.current_page + '/' + brows.last_page" class="form-control"
                style="text-align:center;" type="text" @change="getBrows('bc/brows/browslist?page=' + p)" v-model="p"
                size="2"></div>
            <button class="btn btn-primary" @click="getBrows(brows.next_page_url)" :disabled="!brows.next_page_url">
              &rsaquo;
            </button>
            <button class="btn btn-primary" @click="getBrows(brows.last_page_url)" :disabled="!brows.next_page_url">
              &raquo;
            </button>
            <!-- <div class="col-md-6" style="padding-left:50px">
              <select class="form-control form-control-sm" v-model="b" @change="getBrows()">
                <option value="">Semua Izin</option>
                <option value=6 >Pemuatan Barang Di Luar Kawasan Pabean</option>
                <option value=1 >Penimbunan Barang Di Luar Kawasan Pabean</option>
              </select>
            </div> -->
            <!-- <div class="col-md-6" style="padding-left:50px">
              <select class="form-control form-control-sm" v-model="c" @change="getBrows()">
                <option value="">Sort by</option>
                <option value="perijinan.td_permohonan.tgl_mohon" >Tanggal Mohon</option>
                <option value="perijinan.td_permohonan.wk_kirim" >Tanggal Kirim</option>
                <option value="perijinan.td_permohonan.tgl_setuju" >Tanggal Setuju</option>
              </select>
            </div> -->
          </div>
        </div>
      </b-card>
      <b-modal hide-footer title="Laporan" size="lg" class="modal-warning" v-model="modaldata" @ok="modaldata = false">
        <div class="row">
          <div class="col-12" style="height:500px;max-width:800px;overflow-y:scroll;overflow-x:scroll;">
            <table v-if="jenis == 1" class="table table-bordered table-hover table-sm">
              <tr>
                <th rowspan="2">No</th>
                <th colspan="2">BC 1.0</th>
                <th colspan="3">BC 1.1</th>
                <th colspan="2">B/L / AWB</th>
                <th rowspan="2">Shipper</th>
                <th rowspan="2">Consignee</th>
                <th colspan="4">Jumlah</th>
                <th rowspan="2"> Lokasi Timbun (Gudang / Lapangan)</th>
                <th rowspan="2"> No. Kontainer</th>
                <th colspan="2"> Waktu (Masuk)</th>
                <th rowspan="2"> No. Segel</th>
                <th colspan="2"> Waktu (Keluar)</th>
                <th colspan="2">Dok. Pengeluaran</th>
                <th rowspan="2">Keterangan</th>
              </tr>
              <tr>
                <th>No</th>
                <th>Tanggal</th>
                <th>No</th>
                <th>Tanggal</th>
                <th>Pos</th>
                <th>No</th>
                <th>Tanggal</th>
                <th>Container</th>
                <th>Kemasan</th>
                <th>Bruto</th>
                <th>Volume</th>
                <th>Tanggal</th>
                <th>Jam</th>
                <th>Tanggal</th>
                <th>Jam</th>
                <th>No</th>
                <th>Tanggal</th>
              </tr>
              <tr v-for="(data, index) in daftar">
                <td>{{ index + 1 }}</td>
                <td>{{ data.no_bc10 }}</td>
                <td>{{ data.tgl_bc10 }}</td>
                <td>{{ data.no_bc11 }}</td>
                <td>{{ data.tgl_bc11 }}</td>
                <td>{{ data.no_pos }}</td>
                <td>{{ data.no_bl }}</td>
                <td>{{ data.tgl_bl }}</td>
                <td>{{ data.shipper }}</td>
                <td>{{ data.consignee }}</td>
                <td>{{ data.jml_cont }}</td>
                <td>{{ data.jml_kemasan }} {{ data.kd_kemasan }}</td>
                <td>{{ data.brutto }}</td>
                <td>{{ data.volume }}</td>
                <td>{{ data.id_gudang }}</td>
                <td>{{ data.no_cont }}</td>
                <td>{{ data.tgl_masuk }}</td>
                <td>{{ data.jam_masuk }}</td>
                <td>{{ data.no_segel }}</td>
                <td>{{ data.tgl_keluar }}</td>
                <td>{{ data.jam_keluar }}</td>
                <td>{{ data.no_dok_keluar }}</td>
                <td>{{ data.tgl_dok_keluar }}</td>
                <td>{{ data.keterangan }}</td>
              </tr>
            </table>
            <table v-if="jenis == 2" class="table table-bordered table-hover table-sm">
              <tr>
                <th rowspan="2">No</th>
                <th colspan="2">BC 1.0</th>
                <th rowspan="2">Nama Sarana Pengangkut</th>
                <th rowspan="2">No. Voy</th>
                <th rowspan="2">Bendera</th>
                <th colspan="2">Pelabuhan</th>
                <th colspan="2">Waktu Kedatangan / Keberangkatan</th>
                <th colspan="4">Jumlah</th>
                <th rowspan="2">Agen Pengangkut</th>
                <th colspan="2">BC 1.1 (Inward)</th>
                <th colspan="2">BC 1.1 (Outward)</th>
                <th rowspan="2">Keterangan</th>
              </tr>
              <tr>
                <th>No</th>
                <th>Tanggal</th>
                <th>Asal</th>
                <th>Tujuan</th>
                <th>Tanggal</th>
                <th>Jam</th>
                <th>Kontainer</th>
                <th>Kemasan</th>
                <th>Bruto</th>
                <th>Volume</th>
                <th>No</th>
                <th>Tanggal</th>
                <th>No</th>
                <th>Tanggal</th>
              </tr>
              <tr v-for="(data2, index) in daftar">
                <td>{{ index + 1 }}</td>
                <td>{{ data2.no_bc10 }}</td>
                <td>{{ data2.tgl_bc10 }}</td>
                <td>{{ data2.nm_sarkut }}</td>
                <td>{{ data2.no_voy }}</td>
                <td>{{ data2.bendera }}</td>
                <td>{{ data2.pel_asal }}</td>
                <td>{{ data2.pel_tujuan }}</td>
                <td>{{ data2.tgl_tiba }}</td>
                <td>{{ data2.jam_tiba }}</td>
                <td>{{ data2.jml_cont }}</td>
                <td>{{ data2.jml_kemasan }} {{ data2.kd_kemasan }}</td>
                <td>{{ data2.bruto }}</td>
                <td>{{ data2.volume }}</td>
                <td>{{ data2.agen_pengangkut }}</td>
                <td>{{ data2.no_bc11_in }}</td>
                <td>{{ data2.tgl_bc11_in }}</td>
                <td>{{ data2.no_bc11_out }}</td>
                <td>{{ data2.tgl_bc11_out }}</td>
                <td>{{ data2.keterangan }}</td>
              </tr>
            </table>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
// import swal from 'sweetalert'
export default {
  data () {
    return {
      draft: '',
      brows: [],
      modaldata: false,
      q: '',
      p: '',
      b: '',
      c: 'perijinan.tl_hdr.id_tl_hdr',
      d: 'desc',
      daftar: [],
      jenis: ''

    }
  },
  created () {
    this.getBrows()
  },
  methods: {
    getBrows (page) {
      if (typeof page === 'undefined') {
        page = 'laporan/browseupload?page=1'
      }
      var auth = {
        npwp: this.$store.getters['auth/user']['npwp'],
        q: this.q,
        p: this.p,
        b: this.b,
        c: this.c,
        d: this.d
      }
      this.$http.post(page, auth)
        .then(response => {
          this.brows = response.data
        })
    },
    unduh (id) {
      var datalaporan = {
        id: id
      }
      this.$http.post('unduh', datalaporan)
    },
    getData (id, jn) {
      var data = {
        id: id,
        jenis: jn
      }
      this.$http.post('laporan/dataupl', data)
        .then(response => {
          this.daftar = response.data
          this.jenis = jn
          this.modaldata = true
        })
    },
    setC (orderBy) {
      if (this.d === 'asc') {
        this.d = 'desc'
      } else {
        this.d = 'asc'
      }
      this.c = orderBy
      this.getBrows()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/Brows/browseupload.vue?38d3e097